module.exports = __webpack_public_path__ + "img/add-photoshoot.5ca8acbc.svg";